export default __webpack_public_path__ + "static/media/models3.a5011c7c.jfif";